import React from "react";
import "./Footer.css";
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Instagram,
  Youtube,
} from "lucide-react";

import Logo from "../assets/headerLogo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid grid-3-cols">
          <div className="footer-col">
            <img src={Logo} alt="Profile" className="footer-logo" />
            <p className="footer-description">
              Consultoria estratégica especializada em clínicas e consultórios
              que desejam crescer e maximizar resultados com excelência.
            </p>
            <div className="footer-socials">
              <a
                href="http://www.linkedin.com/company/arcadiancompany/"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Linkedin className="icon" />
              </a>
              <a
                href="https://www.instagram.com/arcadian.co/"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Instagram className="icon" />
              </a>
              <a
                href="https://www.youtube.com/@Arcadiancompany"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <Youtube className="icon" />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Empresa</h4>
            <ul>
              <li>
                <a href="#quem-somos">Quem Somos</a>
              </li>
              <li>
                <a href="#atuacao">Nossa Atuação</a>
              </li>
              <li>
                <a href="#cases">Cases</a>
              </li>
              <li>
                <a href="#faq">FAQ</a>
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contato</h4>
            <div className="footer-contact">
              <div>
                <Phone className="icon" /> <span>(77) 9 8163-1390</span>
              </div>
              <div>
                <Mail className="icon" />{" "}
                <span>contato@projetoarcadian.com.br</span>
              </div>
              <div>
                <MapPin className="icon" /> <span>Belo Horizonte, MG</span>
              </div>
            </div>
            <div className="footer-cta">
              <a
                href="https://wa.me/5577981631390?text=Ol%C3%A1%2C%20vim%20do%20site%20da%20Arcadian%20e%20gostaria%20faturar%20mais%20com%20a%20minha%20cl%C3%ADnica!"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn-primary">
                  Entre em contato conosco
                </button>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>
            © 2024 - {currentYear} Arcadian. Todos os direitos reservados.
          </span>
          <h1 className="e2tcode">
            Desenvolvido por{" "}
            <a href="https://e2tcode.com" target="_blank" rel="noreferrer">
              E2T Code
            </a>
          </h1>
          {/* <div className="footer-links">
            <a href="https://google.com" target="_blank" rel="noreferrer">
              Política de Privacidade
            </a>
            <a href="https://google.com" target="_blank" rel="noreferrer">
              Termos de Uso
            </a>
            <a href="https://google.com" target="_blank" rel="noreferrer">
              LGPD
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
